(ns rlws.iot-cloud.frontend.config)

(def debug? ^boolean goog.DEBUG)

(goog-define is-dev false)

;; The path within site for the Rice Lake API
(goog-define api-path "/api")

;; The path within site for it's own API
(goog-define site-api-path "/_site")

;; The server origin for sending requests to site
(goog-define site-api-origin "")

;; The server origin for sending requests to the state service
(goog-define state-api-origin "")

;; This is until we implement real authorization across state => site
(goog-define state-secret "395609d0-621b-4f02-838a-a2353addbd9a")

;; AWS cloudwatch logging
(goog-define aws-access-key-id "")
(goog-define aws-secret-access-key "")
(goog-define aws-region "")
(goog-define aws-log-group-name "")

;; Auth0 Availability
(goog-define is-auth0-available false)

(def asset-liveness-timeout-ms
  "The time after the last status update before we consider an asset offline"
  20000)

(def home-route :assets)

(def sse-event-whitelist {:status :rlws.iot-cloud.frontend.events/alert-status
                          :gateway-status :rlws.iot-cloud.frontend.events/gateway-status})
